import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { PageEvent } from "@angular/material/paginator";

import { Brand } from "../../../features/brand/domain/models/brand";
import { BrandCampaign } from "../../../shared/models/brandCampaign";
import { BrandService } from "../../../shared/services/api/brand.service";
import { NotificationService } from "../../../shared/services/notification.service";
import { BrandCampaignService } from "../shared/services/brand-campaign.service";

export type BrandCampaignMoveDialogData = BrandCampaign;
export type BrandCampaignMoveDialogResult = true;

@Component({
  selector: "app-brand-campaign-move-dialog",
  templateUrl: "./brand-campaign-move-dialog.component.html",
  styleUrls: ["./brand-campaign-move-dialog.component.scss"],
})
export class BrandCampaignMoveDialogComponent implements OnInit {
  public moving = false;
  public loading = false;
  public brands: Brand[] = [];
  public totalBrands = 0;
  public limit = 10;
  public pageIndex = 0;

  private offset = 0;
  private selectedBrand?: Brand;
  private campaign: BrandCampaign;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: BrandCampaignMoveDialogData,
    private readonly dialogRef: MatDialogRef<
      BrandCampaignMoveDialogComponent,
      BrandCampaignMoveDialogResult
    >,
    private readonly notificationService: NotificationService,
    private readonly brandCampaignService: BrandCampaignService,
    private readonly brandService: BrandService,
  ) {
    this.campaign = data;
  }

  public ngOnInit(): void {
    this.getBrands();
  }

  private getBrands(): void {
    this.loading = true;
    this.brandService.getBrands(this.offset, this.limit).subscribe((brands) => {
      // Can not move to the same brand
      this.brands = brands.filter((b) => b.id !== this.campaign.brand.id);
      this.totalBrands = brands.length;
      this.loading = false;
    });
  }

  public selectBrand(brand: Brand): void {
    this.selectedBrand = brand;
  }

  public isBrandSelected(brand: Brand): boolean {
    if (!this.selectedBrand) {
      return false;
    }

    return this.selectedBrand.id === brand.id;
  }

  public move(): void {
    if (!this.selectedBrand) {
      throw new Error(`Campaign can't be moved without selecting a brand.`);
    }

    this.moving = true;
    this.brandCampaignService
      .moveCampaign(this.campaign.id, this.selectedBrand.id)
      .subscribe({
        next: () => {
          this.dialogRef.close(true);
        },
        error: () => {
          this.notificationService.error(
            "brand.moveCampaign.errorMovingTheCampaign",
          );
        },
        complete: () => {
          this.moving = false;
        },
      });
  }

  public isMoveButtonDisabled(): boolean {
    if (!this.selectedBrand) {
      return true;
    }

    return this.moving;
  }

  public onPageChange(event: PageEvent) {
    this.offset = this.limit * event.pageIndex;
    this.pageIndex = event.pageIndex;
    this.getBrands();
  }
}
